export default {
  marshal: (data) => {
    return {
      backgroundImage: data.formAppearanceConfig.backgroundImage,
      primaryColor: data.formAppearanceConfig.primaryColor,
      primaryTextColor: data.formAppearanceConfig.primaryTextColor,
      // We don't use accentColor and secondaryTextColor. Forms based on primaryColor,primaryTextColor and white color
      accentColor: data.formAppearanceConfig.primaryColor,
      secondaryTextColor: data.formAppearanceConfig.primaryTextColor,

      intro: data.intro || {},

      footer: data.footer || {},

      header: data.header || {},

      languages: data.languages || [],
      defaultLanguage: data.defaultLanguage,
      defaultCountryPhoneCode: data.defaultCountryPhoneCode
        ? data.defaultCountryPhoneCode.toLowerCase()
        : 'de',
      hideLanguagesFlags: data.hideLanguagesFlags ?? false,

      showMyAccreditation: false,

      submitConfig: data.submitConfig || {},

      printLayoutId: data.printLayoutId || null,
      projectId: data.projectId || null,
      formType: data.formType || null,
      formDefId: data.formDefId || null,
      submitResultScreens: data.submitResultScreens || [],

      textsOverwritings: data.textsOverwritings || {},
      quotaExceededMessage: data.quotaExceededMessage || {},
      summaryPageFieldsFromAccount: data.summaryPageFieldsFromAccount || [],
    };
  },
};
